import React, { useState, useEffect } from 'react';
import CarLogo from './components/CarLogo';
import API_BASE_URL from './config';

function Cars() {
  const [cars, setCars] = useState([]);
  const [carName, setCarName] = useState('');
  const [message, setMessage] = useState('');
  const [showDelete, setShowDelete] = useState(false);
  const [deleteCarId, setDeleteCarId] = useState(null);
  const [deleteUsername, setDeleteUsername] = useState('');
  const [deletePassword, setDeletePassword] = useState('');
  const [deleteMsg, setDeleteMsg] = useState('');
  const [carSummary, setCarSummary] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/cars`)
      .then(res => res.json())
      .then(data => setCars(data));
  }, []);

  const handleAddCar = async (e) => {
    e.preventDefault();
    setMessage('');
    const res = await fetch(`${API_BASE_URL}/cars`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: carName })
    });
    const data = await res.json();
    if (data.success) {
      setCars([...cars, { id: data.id, name: carName }]);
      setCarName('');
      setMessage('تمت إضافة السيارة بنجاح');
    } else {
      setMessage(data.message || 'حدث خطأ');
    }
  };

  const handleDeleteCar = async (carId) => {
    const username = prompt('أدخل اسم المستخدم للتأكيد:');
    const password = prompt('أدخل كلمة السر للتأكيد:');
    
    if (!username || !password) {
      setDeleteMsg('تم إلغاء عملية الحذف');
      return;
    }

    try {
      const res = await fetch(`${API_BASE_URL}/cars/${carId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      
      const data = await res.json();
      
      if (data.success) {
        setCars(cars.filter(car => car.id !== carId));
        setMessage(`تم حذف السيارة بنجاح${data.deletedMovements > 0 ? ` مع ${data.deletedMovements} حركة مرتبطة` : ''}`);
        setDeleteMsg('');
      } else {
        if (res.status === 409) {
          // السيارة مرتبطة بحركات
          const confirmDelete = window.confirm(`${data.message}\nهل تريد المتابعة؟`);
          if (confirmDelete) {
            // إعادة المحاولة مع تأكيد الحذف المتتالي
            const res2 = await fetch(`${API_BASE_URL}/cars/${carId}`, {
              method: 'DELETE',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ username, password, confirmCascade: true })
            });
            
            const data2 = await res2.json();
            if (data2.success) {
              setCars(cars.filter(car => car.id !== carId));
              setMessage(`تم حذف السيارة بنجاح مع ${data2.deletedMovements} حركة مرتبطة`);
              setDeleteMsg('');
            } else {
              setDeleteMsg(data2.message || 'حدث خطأ في الحذف');
            }
          }
        } else {
          setDeleteMsg(data.message || 'حدث خطأ في الحذف');
        }
      }
    } catch (error) {
      setDeleteMsg('حدث خطأ في الاتصال بالخادم');
    }
  };

  return (
    <div dir="rtl" className="w-full max-w-7xl mx-auto p-6" style={{ direction: 'rtl', textAlign: 'right' }}>
      <div className="mb-8">
        <h2 className="text-3xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-2">
          إدارة النقل
        </h2>
        <p className="text-gray-600">إضافة وإدارة وسائل النقل في النظام</p>
      </div>
      
      <div className="card shadow-modern mb-8">
        <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
          <span className="w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center text-white text-sm">+</span>
          إضافة سيارة جديدة
        </h3>
        <form onSubmit={handleAddCar} className="flex gap-4 items-end">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">اسم السيارة</label>
            <input 
              className="input-modern" 
              type="text" 
              value={carName} 
              onChange={e => setCarName(e.target.value)} 
              required 
              placeholder="أدخل اسم السيارة"
            />
          </div>
          <button className="btn-primary" type="submit">
            إضافة السيارة
          </button>
        </form>
        
        {message && <div className="alert-success mt-4">{message}</div>}
        {deleteMsg && <div className="alert-error mt-4">{deleteMsg}</div>}
      </div>

      <div className="card shadow-modern">
        <h3 className="text-xl font-semibold mb-6 flex items-center gap-2">
          <span className="w-8 h-8 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-lg flex items-center justify-center text-white text-sm">📋</span>
          قائمة السيارات ({cars.length})
        </h3>
        
        {cars.length === 0 ? (
          <div className="text-center py-12 text-gray-500">
            <div className="flex justify-center mb-4">
              <CarLogo size="xl" className="text-blue-600" />
            </div>
            <p className="text-lg">لا توجد سيارات مسجلة بعد</p>
            <p className="text-sm">أضف أول سيارة باستخدام النموذج أعلاه</p>
          </div>
        ) : (
          <div className="grid gap-4">
            {cars.map((car, index) => (
              <div 
                key={car.id} 
                className="group bg-gradient-to-r from-white to-gray-50 p-4 rounded-xl border border-gray-200 hover:border-indigo-300 transition-all duration-300 hover:shadow-lg transform hover:scale-102"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-xl flex items-center justify-center text-white font-bold">
                      {car.name.charAt(0)}
                    </div>
                    <div>
                      <h4 className="font-semibold text-lg text-gray-800">{car.name}</h4>
                      <p className="text-sm text-gray-500">سيارة رقم {car.id}</p>
                    </div>
                  </div>
                  
                  <button 
                    className="btn-danger opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    onClick={() => handleDeleteCar(car.id)}
                  >
                    حذف
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Cars;